// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeExpense} from "../../WorkIssuanceExpense/expenseSlice";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function RequestExpense({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleRequest = () => {
        dispatchData(changeExpense({rejectedState: true, expenseNewStatus: '2359'}));
        dispatchData(changeWorkIssuance({newStatus:  '2359', updateCdpStatus: true}));
        onMenuClose();
    };



    return (

        <Box>
            {(
                    // rowCdpStatus === "2351" ||  rowCdpStatus === "2359"
                    (rowCdpStatus !== "3709" && rowCdpStatus !== "3242" && rowCdpStatus !== "4553" && rowCdpStatus !== "2351" && rowCdpStatus !== "2359" && showExpense === true)
                ) &&
                <MenuItem onClick={handleRequest}>
                    <ListItemIcon>
                        <RequestPageIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Request</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
